import { map } from 'rxjs/operators';
import { ofType, combineEpics } from 'redux-observable';
// ---- external imports ----

import { loadingActions } from '~/store';
import { GAME_LOADED_START, GAME_LOADED_ENDED, GAME_LOADED } from '~/store/game/actionTypes';
// ---- internal imports ----


const startGameLoading = (action$) => action$.pipe(
	ofType(GAME_LOADED_START),
	map(() => loadingActions.start(GAME_LOADED))
);

const endGameLoading = (action$) => action$.pipe(
	ofType(GAME_LOADED_ENDED),
	map(() => loadingActions.end(GAME_LOADED))
);


export default combineEpics(
	startGameLoading,
	endGameLoading
);
